import { useTranslations } from "@ui/providers/useTranslations";

import { UiCopyOutlineIcon } from "@jti/brand-icons/ui-copy-outline";
import { toast } from "@jti/core-components/components/Toaster";
import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";

import styles from "./CopyButton.module.scss";

export type CopyButtonType = {
  text: string;
  className?: string;
};

// TODO: move to utils
export const copyToClipboard = (text: string): void => {
  if ("clipboard" in navigator) {
    navigator.clipboard.writeText(text);
  } else {
    document.execCommand("copy", true, text);
  }
};

let canSend = true;

export const CopyButton: React.FC<CopyButtonType> = ({ text, className }) => {
  const { __ } = useTranslations();
  const onClick = () => {
    if (canSend) {
      canSend = false;

      setTimeout(() => {
        canSend = true;
      }, 1000);
      toast.success(__("copy.code.button"));
    }

    copyToClipboard(text);
    dispatchTrackingEvent(TrackingEvents.TrackingReferralCodeCopyButtonClick);
  };

  return (
    <button
      type="button"
      className={className}
      onClick={onClick}
      data-testid={"copy-button"}
      aria-label={__("copy.code.button.label")}
    >
      <UiCopyOutlineIcon width="19px" height="19px" className={styles.icon} aria-hidden="true" />
    </button>
  );
};
